import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';

import {UseGetOdontoDatesQueryProps} from './types';
import {getOdontoDates} from '../../services/getOdontoDates';
import {useQueryParams} from 'presentation/pages';

export function useGetOdontoDatesQuery({enabled}: UseGetOdontoDatesQueryProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {SEARCH_PARAMS} = useQueryParams();
	const {disability} = SEARCH_PARAMS;

	const params = {
		cdAtendimentoAcessoEspecial: disability,
		cdEspecialidade: Number(bookingData.specialtyCode),
		cdPrestadorJuridico: String(bookingData.unitCode),
		cdUf: bookingData.ufCode.toUpperCase(),
		nmCidade: bookingData.cityName.toUpperCase(),
		tipoPesquisa: '',
		cdSubEspecialidade: bookingData.subSpecialtyCode ? Number(bookingData.subSpecialtyCode) : 0,
		nmBairro: bookingData.odontoUnitDistrictSelected?.toUpperCase(),
	};

	return useQuery({
		queryKey: [QUERY_KEYS.ODONTO_DATES, params],
		enabled: enabled,
		retry: 1,
		queryFn: async ({signal}) => getOdontoDates({signal, ...params}),
		staleTime: 0,
		gcTime: 0,
	});
}
